.comments-container {
    border: 1px solid var(--off-white-dk);
    border-top: none;
}

.comments-tab-container {
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.empty-tab-container {
    height: 100%;
    padding-bottom: 60px;
}
